import { Container, Grid, Typography, Box, Theme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

interface CanAlsoHelpWithList {
  sideJobsList: string[];
  firstName: String;
}
const CanAlsoHelpWith = ({ sideJobsList, firstName }: CanAlsoHelpWithList) => {
  const isMobileOrSmaller = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  return (
    <Container maxWidth="md" sx={{ pt: 1 }}>
      <Typography variant={isMobileOrSmaller ? 'h2' : 'h1'} mb={2}>
        {firstName} can also help with:
      </Typography>
      <Grid container>
        {sideJobsList.map((value) => (
          <Grid item xs={12} sm={4} key={value}>
            <Box
              fontSize="body2.fontSize"
              display="list-item"
              mx={2.5}
              my={1}
              data-testid="can-help-list">
              {value}
            </Box>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default CanAlsoHelpWith;
